interface FocusCardProps {
  title: string;
  description: string;
  icon: string;
}

export default function FocusCard({ title, description, icon }: FocusCardProps) {
  return (
    <div 
      className="focus-card group opacity-0 translate-y-8 transition-all duration-700 cursor-pointer"
      style={{
        background: 'rgba(255, 255, 255, 0.6)',
        backdropFilter: 'blur(20px)',
        border: '1px solid rgba(124, 58, 237, 0.12)',
        borderRadius: '24px',
        padding: '48px 40px 44px 40px',
        boxShadow: '0 8px 32px rgba(10, 10, 15, 0.04)',
        minHeight: '320px'
      }}
      onMouseEnter={(e) => {
        e.currentTarget.style.transform = 'translateY(-8px)';
        e.currentTarget.style.boxShadow = '0 16px 48px rgba(124, 58, 237, 0.15)';
        e.currentTarget.style.borderColor = 'rgba(0, 212, 255, 0.4)';
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.transform = 'translateY(0)';
        e.currentTarget.style.boxShadow = '0 8px 32px rgba(10, 10, 15, 0.04)';
        e.currentTarget.style.borderColor = 'rgba(124, 58, 237, 0.12)';
      }}
    >
      <div className="mb-5 w-8 h-8 flex items-center justify-center">
        <div 
          className="w-8 h-8 rounded-lg flex items-center justify-center transition-transform duration-400 group-hover:rotate-[5deg]"
          style={{
            background: 'linear-gradient(135deg, #00D4FF 0%, #7C3AED 100%)'
          }}
        >
          <i className={`ri-${icon}-line text-white text-xl`}></i>
        </div>
      </div>

      <h3 
        className="text-xl md:text-2xl font-semibold text-gray-900 mb-4 leading-tight"
        style={{ fontFamily: "'Inter', sans-serif" }}
      >
        {title}
      </h3>

      <p 
        className="text-sm md:text-base text-gray-700 leading-relaxed"
        style={{ 
          fontFamily: "'Inter', sans-serif",
          lineHeight: '1.65'
        }}
      >
        {description}
      </p>
    </div>
  );
}
